// Pointing at what changed rather than which line changed, which is the difference between reading a diff and hunting.
export const SAMPLE_LEFT = "The quick brown fox\njumps over the lazy dog.\nPack my box with five dozen liquor jugs.\n";
export const SAMPLE_RIGHT = "The quick brown fox\nleaps over the lazy dog.\nHow vexingly quick daft zebras jump!\n"
  + "Pack my box with five dozen liquor jugs.\n";
